import { EntityFieldPath } from '../../../../../Entity/Path/@Model/EntityFieldPath';

export default function isConnection(fieldPath: EntityFieldPath): boolean
{
    return fieldPath.isRelationship;
}
